import type { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

import type { Observable } from 'rxjs';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor() {
    if (!environment.api) {
      throw new Error('Environment variable "api" is not set.');
    }
  }

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url.startsWith('/api')) {
      const apiReq = req.clone({ 
        url: `${environment.api}${req.url.substring(req.url.indexOf('/', 1))}`,
        withCredentials: true // BFF: Ensure cookies are sent with API requests
      });
      return next.handle(apiReq);
    }

    return next.handle(req);
  }
}
